import { Box } from "@mui/material";

export default function Spinner({ width }) {
    return (
        <Box width={width}>
            <div className="spinner"></div>
        </Box>
    )
}